import React from "react";
import "./Hero.scss";
import img_1 from './img_1.jpg';
import img_2 from './img_2.jpg';

export default function Hero() {
  return (
    <section className="hero">
      <div className="container hero__inner">
        <div className="hero__text">
          <h1 className="hero__title">WELCOME TO
          TOP RING LATVIA
          GYM FOR EVERYONE
          </h1>
          <p className="hero__subtitle">
            Mēs esam viens no vadošajiem bērnu un jauniešu cīņas mākslu sporta klubiem!
          </p>
          <div className="hero__cta">
            <a className="btn btn--primary" href="/#contact">Pierakstīties uz izmēģinājuma nodarbību</a>
            <a className="btn btn--ghost" href="/#programs">Mūsu programmas</a>
          </div>
        </div>
        <div className="hero__media" aria-hidden>
          {/* <div className="hero__img" /> */}
          <img lassName="hero__img" src={img_1} alt="" />
        </div>
      </div>
    </section>
  );
}
